import {Component} from 'ng-metadata/core';
import './wafers.scss';

/**
 * @ngdoc directive
 * @name mwWafers
 * @module mw.components.wafers
 *
 *
 * @description
 * `<mw-wafers>` is a component that renders a wafers according to the Meltwater UX guidelines.
 *
 * @usage
 * <hljs hljs-language="html">
 *  <mw-wafers>
 *    <mw-wafer ng-repeat="wafer in $ctrl.wafers" icon="{{wafer.icon}}" on-delete="$ctrl.click(wafer)" readonly="wafer.readonly">{{wafer.label}}</mw-wafer>
 *    <mw-wafer-actions>
 *       <md-button class="mw-button mw-button--outlined">Action</md-button>
 *    </mw-wafer-actions>
 *  </mw-wafers>
 * </hljs>
 *
 */
@Component({
    selector: 'mw-wafers',
    template: `
        <md-list>
            <ng-transclude></ng-transclude>
            <ng-transclude ng-transclude-slot="actionsSlot"></ng-transclude>
        </md-list>
    `,
    legacy: {
        transclude: {
            'actionsSlot': '?mwWaferActions'
        }
    }
})
export class WafersComponent {
    constructor() {
        'ngInject';
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/wafers/wafers.component.ts